import { atom, useAtom, useSetAtom } from "jotai";

export const defaultLayoutValues = {
  showFullscreen: true,
  mt: "mt-4",
};

export const layoutAtom = atom(defaultLayoutValues);
const useLayout = () => {
  const atom = useAtom(layoutAtom);
  return atom;
};

export const useSetLayout = () => useSetAtom(layoutAtom);

export default useLayout;
